import React, { useEffect, useState } from "react";
import { Card, Col, Layout, message, Result, Row, Skeleton, Table, Tag, theme, Typography } from "antd";
import AppLogo from "../../assets/images/PrefectosLogos.png";
import { useParams } from "react-router-dom";
import Loading from "../loading/Loading";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import AuthService from "../auth/AuthService";
import moment from "moment";
import { showMessage } from "../Utils/message";

const Auth = new AuthService();
const { Header, Content } = Layout;
const { Text } = Typography;
const PalletInfo = () => {
  const { id } = useParams();

  const layoutDispatch = useLoadingDispatch();
  const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
  const [routeData, setRouteData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      showLoading(layoutDispatch);
      try {
        const res = await Auth.fetch(`/p/route-packing?pallet_security_code=${id}`);
        if (res?.ack) {
            setRouteData(res?.route_data);
        } else {
            setRouteData([]);
        }
      } catch (err) {
        showMessage("error", "Something went wrong while fetching route data.");
      } finally {
        hideLoading(layoutDispatch);
      }
    };

    fetchData();
  }, []);

  const getTotalWeight = () => {
    if (!Array.isArray(routeData)) return 0;
    return routeData.reduce((total, item) => {
        const weight = item.item_total_weight || 0;
        return total + weight;
    }, 0);
};

const getTotalPickedWeight = () => {
    if (!Array.isArray(routeData)) return 0;
    return routeData.reduce((total, item) => {
        const weight = item.item_weight || 0;
        const qty = item.packed_quantity || 0;
        return total + weight * qty;
    }, 0);
};

  const dataCol = [
    {
    title: "Sr No.",
    render: (_, __, index) => <span>{index + 1}</span>,
    width: 60, 
  },
    // {
    //     title: 'Shop Code',
    //     render(record) {
    //         return (
    //             <span>{record ? `${record?.customer_name}` : '-'}</span>
    //         );
    //     }
    // },
    // {
    //     title: 'Shop Name',
    //     render(record) {
    //         return (
    //             <span>{record ? `${record?.customer_project_id}` : '-'}</span>
    //         );
    //     }
    // },
     {
        title: 'Shop',
        render(record) {
            return (
                <span>{record ? `${record?.customer_name} - ${record?.customer_project_id}` : '-'}</span>
            );
        }
    },
    {
        title: 'Item',
        render(record) {
            return (
                <span>{record ? `${record?.item_id} - ${record?.item_name}` : '-'}</span>
            );
        }
    },

    // {
    //     title: 'Picked QTY',
    //     render(record) {
    //         return (
    //             <span>{record?.picked_quantity ? record?.picked_quantity : 0}</span>
    //         );
    //     },
    //     align: 'center'

    // },
    {
        title: 'Ordered Quantity',
        render(record) {
            return (
                <span>{record?.quantity ? record?.quantity : 0}</span>
            );
        },
        align: 'center'
    },
    {
        title: 'Packed Quantity',
        render(record) {
            return (
                <span>{record?.packed_quantity ? record?.packed_quantity : 0}</span>
            );
        },
        align: 'center'
    },
    // {
    //     title: 'Status',
    //     align: 'center',
    //     render(record) {
    //         return (
    //             <>
    //                 {record?.packed_by > 0 ? (
    //                     <Tag color='success' style={{ fontWeight: 'bold', fontSize: '15px' }}>Picked</Tag>
    //                 ) : (
    //                     <Tag color='error' style={{ fontWeight: 'bold', fontSize: '15px' }}>Pending</Tag>
    //                 )
    //                 }
    //             </>
    //         );
    //     }
    // },
  ]

  return (
    <Layout>
      <Header 
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
      >
        <div style={{ display: "flex" }} className="demo-logo">
          <img style={{ height: "36px" }} src={AppLogo} alt="appIcon" />
        </div>
      </Header>
      <Content style={{ padding: "0", height: "92vh" }}>
        <div style={{ padding: 0, minHeight: "92vh", background: colorBgContainer, borderRadius: borderRadiusLG }}>
            <div style={{padding: 10}}>
            <Row gutter={[16, 16]} style={{ marginTop: 8, marginRight: 4 }}>
                            
                            <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Date'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {routeData[0]?.delivery_date ? moment(routeData[0]?.delivery_date).format('DD-MM-YYYY') : '-'}
                                    </Tag>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Route'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {routeData[0]?.route ? routeData[0]?.route : 'N/A'}
                                    </Tag>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Vehicle'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {routeData[0]?.registration_number ? routeData[0]?.registration_number : 'N/A'}
                                    </Tag>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Driver'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {routeData[0]?.driver ? routeData[0]?.driver : 'N/A'}
                                    </Tag>
                                </Card>
                            </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 8, marginRight: 4 }}>
                        <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Pallet No.'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {routeData[0]?.pallet_id ? routeData[0]?.pallet_id : '-'}
                                    </Tag>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Pallet Weight'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {`${getTotalWeight().toFixed(2)} Kg`}
                                    </Tag>
                                </Card>
                            </Col>
                            {/* <Col xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {'Picked Weight'}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {`${getTotalPickedWeight().toFixed(2)} Kg`}
                                    </Tag>
                                </Card>
                            </Col> */}
                    </Row>
            <Table
            columns={dataCol}
            dataSource={routeData}
            pagination={false}
            style={{ overflowX: "auto", marginTop: 10 }}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
           />
            </div>
          
        </div>
      </Content>
      <Loading />

    </Layout>
  );
};

export default PalletInfo;
